/**
 * Global Session Manager
 * Handles session expiration and provides a centralized way to manage authentication state
 */

class SessionManager {
  constructor() {
    this.listeners = [];
    this.isSessionExpired = false;
  }

  /**
   * Add a listener for session expiration events
   */
  addListener(callback) {
    this.listeners.push(callback);
    return () => {
      this.listeners = this.listeners.filter(listener => listener !== callback);
    };
  }

  /**
   * Notify all listeners about session expiration
   */
  notifySessionExpired() {
    this.isSessionExpired = true;
    this.listeners.forEach(callback => callback());
  }

  /**
   * Clear session expiration state
   */
  clearSessionExpired() {
    this.isSessionExpired = false;
  }

  /**
   * Check if session is currently expired
   */
  getSessionExpired() {
    return this.isSessionExpired;
  }

  /**
   * Handle session expiration by notifying listeners and redirecting
   */
  handleSessionExpiration() {
    // Notify listeners
    this.notifySessionExpired();

    // Redirect to login page
    if (window.location.pathname !== '/login') {
      window.location.href = '/login';
    }
  }
}

// Export singleton instance
const sessionManager = new SessionManager();
export default sessionManager;
